<mat-progress-bar
  color="primary"
  [mode]="progressMode"
  *ngIf="loadingStatus">
</mat-progress-bar>
